// currencyToCountry.js
// Maps your specific currencies to country flags
export const currencyToCountry = {
  // Your active currencies
  "EUR": "EU",   // Euro (European Union flag)
  "USD": "US",   // US Dollar
  "CHF": "CH",   // Swiss Franc
  "GBP": "GB",   // British Pound (UK flag)
  "BAM": "BA",   // Bosnia-Herzegovina Convertible Mark
  "HRK": "HR",   // Croatian Kuna (Croatia)
  "AUD": "AU",   // Australian Dollar
  "CAD": "CA",   // Canadian Dollar
  "HUF": "HU",   // Hungarian Forint
  "NOK": "NO",   // Norwegian Krone
};